import React from 'react';
import { useChatStore } from '../../store/chatStore';
// import { Header } from './ui/Header'; // Header will be provided by Layout
import { Layout } from '../layout/Layout'; // Import Layout
import { HeroSection } from './sections/HeroSection';
import { FeaturesSection } from './sections/FeaturesSection';
import { BenefitsSection } from './sections/BenefitsSection';
import { CTASection } from './sections/CTASection';

export function LandingPage() {
  const { setIsOpen } = useChatStore();
  
  const handleChatOpen = () => {
    setIsOpen(true);
  };

  return (
    <Layout>
      {/* <Header /> removed, Layout provides its own header */}
      <main className="pt-16"> {/* Add padding-top to account for fixed header - this might need adjustment based on Layout's header */}
        <HeroSection onChatOpen={handleChatOpen} />
        <FeaturesSection />
        <BenefitsSection onChatOpen={handleChatOpen} />
        <CTASection onChatOpen={handleChatOpen} />
      </main>
    </Layout>
  );
}